import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import {
  adminLoginReducer,
  forgotpasswordReducer,
  resetpasswordReducer,
  userViewReducer,
  accreditedInvestorReducer,
  countryListReducer,

  userInvestmentViewReducer,
  ViewFollowersDetailsReducer,
} from "./redux/reducers/adminReducers";
import {
  campaignViewReducer,
  languageViewReducer,
  adminViewReducer,
  transactionViewReducer,
} from "./redux/reducers/campaignReducers";
import { dealFlowReducer } from "./redux/reducers/dealFlowReducer";
import { secondaryMarketReducer } from "./redux/reducers/secondaryMarketReducer";

const reducer = combineReducers({
  //this will contain our reducers
  adminLogin: adminLoginReducer,
  forgotPassword: forgotpasswordReducer,
  resetPassword: resetpasswordReducer,
  campaignView: campaignViewReducer,
  userView: userViewReducer,
  accreditedView: accreditedInvestorReducer,
  languageView: languageViewReducer,
  adminView: adminViewReducer,
  transactionView: transactionViewReducer,
  countryListView: countryListReducer,

  userInvestment: userInvestmentViewReducer,
  ViewFollowersDetails: ViewFollowersDetailsReducer,

  // Deal Flow - Admin rating and interest stats
  dealFlow: dealFlowReducer,
  // Secondary Market
  secondaryMarket: secondaryMarketReducer,
});

const adminInfo = localStorage.getItem("admin")
  ? JSON.parse(localStorage.getItem("admin"))
  : null;

const initialState = {
  adminLogin: { user: adminInfo },
};

const middleware = [thunk];

const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
